import React, {useEffect, useState, useRef} from 'react'
import ReactDOM from 'react-dom'
import useOnClickOutside from '@hooks/useOnClickOutside';

function Modal({children, onClose, setOpen}) {
  const ref = useRef();

  useOnClickOutside(ref, () => setOpen(false));

  const keydownHandler = ({ key }) => {
    switch (key) {
      case 'Escape':
        setOpen(false);
        break;
      default:
    }
  };
  useEffect(() => {
    document.addEventListener('keydown', keydownHandler);
    return () => document.removeEventListener('keydown', keydownHandler);
},[])


  return (
    <div className='modal'>
      <div className='modal-content' ref={ref}>
        {children}
      </div>
    </div>
  )
}

export default function ModalPortal({children, onClose, setOpen}) {
  return ReactDOM.createPortal(
    <Modal onClose={onClose} setOpen={setOpen}>
      {children}
    </Modal>,
    document.getElementById('portal')
  )
}